import request from '@/utils/request';
import { BASE_API } from '@/utils/consts'

// 查询订单物流信息
export function queryOrderLogisticsList(data) {
  return request(`${BASE_API}/logistics/list`, {
    method: 'post',
    data
  })
}

// 新增订单收款信息
export function addOrderPayment(data) {
  return request(`${BASE_API}/payment/create`, {
    method: 'post',
    data
  })
}

// 修改订单收款信息
export function updateOrderPayment(data) {
  return request(`${BASE_API}/payment/update`, {
    method: 'put',
    data
  })
}

// 删除订单收款信息
export function deleteOrderPayment(id) {
  return request(`${BASE_API}/payment/delete/${id}`, {
    method: 'delete'
  });
}
